module.exports = __webpack_public_path__ + "static/media/linked-in-black.a7f8e1e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/linked-in-black.svg
// module id = 221
// module chunks = 0